module.exports = __webpack_public_path__ + "img/tv.8f6deca7.svg";